import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Variant } from '@/interfaces/transaction-result';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { deofuscate, ofuscate } from '@/utils/obfuscation';

@Component({
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css'],
})
export class ResultComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
  ) { }

  email: string = '';
  id: number = 0;
  userId: number = 0;
  variant: Variant = 'success';
  message: string = '';
  messageBold: string = '';
  requestVariant: 'personal' | 'third' = 'personal';

  actionButtonText: string = '';
  actionButtonPath: string = '';
  actionButtonDescription: string = '';

  subtitle: string = 'Tu solicitud de renovación ha sido enviada';

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    { text: 'Solicitar', path: '/license/renew' },
  ]

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.id = params.id || 0;
      this.userId = params.userId || 0;
      this.email = params.email || '';
      this.variant = params.variant || 'success';

      this.requestVariant = params.requestVariant || 'personal';

      if (this.variant === 'success') {
        this.message = `Una copia de su solicitud fue enviada al correo electrónico ${this.email}`;
        this.messageBold = `N° solicitud: ${this.id}`;
        this.actionButtonText = 'Ver detalle de solicitud';
        this.actionButtonDescription = 'Puedes ver el detalle de la solicitud a través del siguiente link';

        const ofuscatedId = ofuscate({ id: this.id });
        this.actionButtonPath = `/license/show/${ofuscatedId}`;
      }
      if (this.variant === 'failure') {
        this.subtitle = 'Hubo un problema y no hemos podido enviar la solicitud de Renovación. Por favor intenta de nuevo.';
      }
    });
  }

}
